import { type OrganizationSettings } from '@lib/types/organizationSettings.types'
import { type InstanceSettings } from '@lib/types/instanceSettings.types'

export const DEFAULT_PITCHER_SETTINGS: OrganizationSettings & InstanceSettings = {
  file_annotations_mode: 'admin',
  minimum_event_duration_in_call: 3,
}

export const PITCHER_SETTINGS_KEY = 'pitcher_settings'
